/**
 * Environment variable compatibility layer
 * Maps REACT_APP_* variables to Vite's import.meta.env
 */

// Polyfill process.env for legacy code using REACT_APP_ prefix
if (typeof process === 'undefined') {
  ;(window as any).process = { env: {} }
}

// Map REACT_APP_ environment variables from Vite's import.meta.env
const env = import.meta.env as Record<string, string>

Object.keys(env).forEach((key) => {
  if (key.startsWith('REACT_APP_')) {
    process.env[key] = env[key]
  }
})

// Also make VITE_ vars available as REACT_APP_ for compatibility
process.env.REACT_APP_API_URL =
  env.REACT_APP_API_URL || env.VITE_API_BASE_URL?.replace(/\/$/, '') || ''
process.env.REACT_APP_FALLBACK_NO_PROJECT_URL =
  env.REACT_APP_FALLBACK_NO_PROJECT_URL || env.VITE_FALLBACK_NO_PROJECT_URL || ''
// GeoServer requests should use relative URLs so they go through the same origin's proxy
// (Apache on frontend server proxies /geoserver to local geoserver container)
process.env.REACT_APP_GEOSERVER_URL = env.REACT_APP_GEOSERVER_URL || ''
process.env.REACT_APP_GEOSERVER_URL_WMS = env.REACT_APP_GEOSERVER_URL_WMS || '/geoserver/wms'
process.env.REACT_APP_GEOSERVER_LAYER_AOI =
  env.REACT_APP_GEOSERVER_LAYER_AOI || env.VITE_GEOSERVER_LAYER_AOI || 'ne:aois'
process.env.REACT_APP_GEOSERVER_LAYER_ASBESTOS =
  env.REACT_APP_GEOSERVER_LAYER_ASBESTOS || env.VITE_GEOSERVER_LAYER_ASBESTOS || ''

// Also set PUBLIC_URL for icons/images
process.env.PUBLIC_URL = ''

export {}
